<template>
    <div>
    <el-form :model="xinxidata" label-position="right" label-width="120px">

        <!-- <fieldset name="询价基本信息" class="elist"> -->
        <el-col :span="23" align="left">
            <h1>企业概括</h1>
        </el-col>
        <el-row :gutter="60">
            <el-col :span="8">
                <!-- <el-tooltip placement="top-start"  effect="light">
                     <div slot="content" >{{ this.dataForm.rfqNo }}</div> -->
                <el-form-item label="企业名称" prop="venderName">
                    <el-input v-model="xinxidata.venderName" disabled></el-input>
                </el-form-item>
                <!-- </el-tooltip> -->
            </el-col>
            <el-col :span="8">
                <el-form-item label="企业性质" prop="enterprisenature">
                  <el-select disabled v-model="xinxidata.enterprisenature" style="width: 100%">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="合资方/合资比例" prop="venturepartner">
                    <el-input v-model="xinxidata.venturepartner" disabled   placeholder="合资方/合资比例"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="60">
            <el-col :span="8">
                <el-form-item label="地址" prop="address">
                    <el-input v-model="xinxidata.address" disabled placeholder="地址"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="供应商代码" prop="venderCode">
                    <el-input v-model="xinxidata.venderCode" disabled placeholder="供应商代码"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="统一社会信用编码" prop="creditcode" label-width="120px">
                    <el-input  v-model="xinxidata.creditcode" disabled placeholder="统一社会信用编码"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="60">

            <el-col :span="8">
                <el-form-item label="邮政编码" prop="postcode">
                    <el-input v-model="xinxidata.postcode" disabled placeholder="邮政编码"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="法人" prop="legalperson">
                    <el-input v-model="xinxidata.legalperson" disabled placeholder="法人"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="供应商类型" prop="venderSource">
                     <el-input v-model="xinxidata.venderSource" disabled placeholder="供应商类型"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="60">
<!--            <el-col :span="8">-->
<!--                <el-form-item label="税号" prop="taxnum">-->
<!--                   <el-input v-model="xinxidata.taxnum" disabled placeholder="税号"></el-input>-->
<!--                </el-form-item>-->
<!--            </el-col>-->
            <el-col :span="8">
                <el-form-item label="开户行" prop="bankname">
                   <el-input v-model="xinxidata.bankname" disabled placeholder="开户行"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="传真" prop="fax">
                    <el-input v-model="xinxidata.fax" disabled placeholder="传真"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-col :span="23" align="left">
           <h1> 电子银行承兑汇票业务信息</h1>
        </el-col>
        <el-row :gutter="60">
            <el-col :span="8">
                <el-form-item label="户名" prop="accountname">
                    <el-input v-model="xinxidata.accountname" disabled placeholder="户名"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="账号" prop="accountnum">
                    <el-input v-model="xinxidata.accountnum" disabled placeholder="账号"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="开户行" prop="bankname">
                    <el-input v-model="xinxidata.bankname" disabled placeholder="开户行"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="60">
            <el-col :span="8">
                <el-form-item label="开户行地址" prop="bankaddress">
                <el-input v-model="xinxidata.bankaddress" disabled placeholder="开户行地址"></el-input>
                </el-form-item>
            </el-col>
<!--               <el-col :span="8">-->
<!--                <el-form-item label="大额支付系统行号" prop="paynum" label-width="130px">-->
<!--                <el-input v-model="xinxidata.paynum" disabled placeholder="大额支付系统行号"></el-input>-->
<!--                </el-form-item>-->
<!--            </el-col>-->
            <el-col :span="8">
              <el-form-item label="银行银联号" prop="swiftCode">
                <el-input disabled v-model="xinxidata.swiftCode"/>
              </el-form-item>
            </el-col>
        </el-row>
        <el-col :span="23" align="left">
            <h1>供应商情况简介</h1>
        </el-col>
         <el-row :gutter="60">
            <el-col style="width: 100%">
                <el-form-item label="供应商情况简介" prop="venderIntroduce">
                <el-input  type="textarea" v-model="xinxidata.venderIntroduce" disabled placeholder="供应商情况简介"></el-input>
                </el-form-item>
            </el-col>
         </el-row>
        <br />
    </el-form>
</div>
</template>
<script>
export default {
    data () {
      return {
        dataForm: {
          key: '',
        },
        options: [
          { label: '私营企业', value: '0' },
          { label: '国有企业', value: '1' },
          { label: '合资企业', value: '2' },
          { label: '其他', value: '3' }
        ],
        targetId:'',
        xinxidata:{
            targetId:'',
            enterprisename:'',
            enterprisenature:'',
            venturepartner:'',
            address:'',
            creditcode:'',
            postcode:'',
            legalperson:'',
            venderType:'',
            venderCode:'',
            venderName:'',
            taxnum:'',
            bankname:'',
            fax:'',
            accountname:'',
            accountnum:'',
            paynum:'',
            venderIntroduce:'',
            swiftCode:'',

        },

        options2: [{
                value: '0',
                label: '非一汽集团配套商'
            }, {
                value: '1',
                label: '一汽集团配套商'
            }],
      }
    },
   methods: {
   init(id)
   {
    //this.xinxidata.targetId = id
    this.getDataList(id)
        },
     // 获取数据列表
    getDataList(id) {
        // debugger
        // const me = this
        if(id){
        this.targetId = id
        this.dataListLoading = true
        this.$http({
        url: this.$http.adornUrl('/applyformbasicinfo/tvenderbasicinfo/jibenXinxi'),
        method: 'POST',
        params: this.$http.adornParams({
             'targetId': this.targetId,
             'page': 0,
            'limit': 1000
                })
        }).then(({
             data
        }) => {
            // debugger
        if (data && data.code === 0) {
            this.xinxidata = data.xinXi[0]
            this.xinxidata.enterprisename = data.xinXi[0].enterprisename
            this.xinxidata.enterprisenature = data.xinXi[0].enterprisenature
            this.xinxidata.venturepartner = data.xinXi[0].venturepartner
            this.xinxidata.address = data.xinXi[0].address
            this.xinxidata.creditcode = data.xinXi[0].creditcode
            this.xinxidata.postcode = data.xinXi[0].postcode
            this.xinxidata.legalperson = data.xinXi[0].legalperson
            this.xinxidata.venderCode = data.xinXi[0].venderCode
            this.xinxidata.venderName = data.xinXi[0].venderName
            this.xinxidata.taxnum = data.xinXi[0].taxnum
            this.xinxidata.bankname = data.xinXi[0].bankname
            this.xinxidata.fax = data.xinXi[0].fax
            this.xinxidata.accountname = data.xinXi[0].accountname
            this.xinxidata.accountnum = data.xinXi[0].accountnum
            this.xinxidata.paynum = data.xinXi[0].paynum
            this.xinxidata.venderIntroduce = data.xinXi[0].venderIntroduce
            this.xinxidata.venderSource = data.xinXi[0].venderSource
            this.xinxidata.bankaddress = data.xinXi[0].bankaddress
            this.xinxidata.swiftCode = data.xinXi[0].swiftCode
             if(data.xinXi[0].venderSource == "0") {
              this.xinxidata.venderSource = "非一汽集团配套商"
            } else {
              this.xinxidata.venderSource = "一汽集团配套商"
            }

            // debugger
        } else {
            this.$message.error(data.msg)
            this.xinxidata = []
            }
        })
    }
    }
    }

}
</script>
